module.exports = __webpack_public_path__ + "img/两颗爱心.f6f7203c.gif";